import { render, staticRenderFns } from "./print_worker_deals.vue?vue&type=template&id=bda4f5f4&scoped=true"
import script from "./print_worker_deals.vue?vue&type=script&lang=js"
export * from "./print_worker_deals.vue?vue&type=script&lang=js"
import style0 from "./print_worker_deals.vue?vue&type=style&index=0&id=bda4f5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bda4f5f4",
  null
  
)

export default component.exports